import React, { useState } from 'react';
import { QadderLogo } from './Logo';
import { useLanguage } from './LanguageContext';

const FEATURES = [
  { key: 'qudraat',    labelKey: 'feat_qudraat' },
  { key: 'trial',      labelKey: 'feat_trial' },
  { key: 'tahsili',    labelKey: 'feat_tahsili' },
  { key: 'unlimited',  labelKey: 'feat_unlimited' },
  { key: 'ai',         labelKey: 'feat_ai' },
  { key: 'stats',      labelKey: 'feat_stats' },
  { key: 'progress',   labelKey: 'feat_progress' },
  { key: 'step',       labelKey: 'feat_step' },
  { key: 'tajamuat',   labelKey: 'feat_tajamuat' },
  { key: 'support',    labelKey: 'feat_support' },
];

const PLANS = [
  {
    id: 'basic',
    nameKey: 'plans_basic',
    icon: '⭐',
    color: '#3b82f6',
    price: 29,
    descKey: 'plans_basicDesc',
    features: {
      qudraat: true,
      trial:   true,
      tahsili: false,
      unlimited: false,
      ai:      false,
      stats:   false,
      progress: false,
      step:    false,
      tajamuat: false,
      support: false,
    },
  },
  {
    id: 'pro',
    nameKey: 'plans_pro',
    icon: '🚀',
    color: '#7c6df8',
    price: 59,
    descKey: 'plans_proDesc',
    recommended: true,
    features: {
      qudraat: true,
      trial:   true,
      tahsili: true,
      unlimited: true,
      ai:      true,
      stats:   true,
      progress: false,
      step:    true,
      tajamuat: false,
      support: false,
    },
  },
  {
    id: 'elite',
    nameKey: 'plans_elite',
    icon: '🌍',
    color: '#f59e0b',
    price: 99,
    descKey: 'plans_eliteDesc',
    features: {
      qudraat: true,
      trial:   true,
      tahsili: true,
      unlimited: true,
      ai:      true,
      stats:   true,
      progress: true,
      step:    true,
      tajamuat: true,
      support: true,
    },
  },
];

export default function PlansScreen({ onSelect, onBack, quizScore }) {
  const { t, isRTL } = useLanguage();
  const [expanded, setExpanded] = useState('pro');

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--bg-page)',
      display: 'flex', flexDirection: 'column',
      direction: isRTL ? 'rtl' : 'ltr', fontFamily: "'Tajawal', sans-serif",
    }}>
      {/* شريط علوي */}
      <div style={{ padding: '14px 20px', borderBottom: '1px solid #1e2a42', background: 'rgba(13,17,23,0.95)' }}>
        <QadderLogo onHome={onBack} size={30} />
      </div>

      {/* المحتوى */}
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '32px 20px 48px' }}>
      <h1 style={{ color: '#f0b429', fontSize: '28px', fontWeight: '800', margin: '0 0 6px' }}>
        {t('plans_title')}
      </h1>
      <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: '14px', marginBottom: '10px' }}>
        {t('plans_subtitle')}
      </p>

      {quizScore && (
        <div style={{
          background: 'var(--bg-card)',
          border: '1px solid var(--border)',
          borderRadius: '12px', padding: '8px 16px', marginBottom: '20px',
          color: 'rgba(255,255,255,0.7)', fontSize: '13px',
        }}>
          {t('plans_yourScore')} {quizScore.score}/{quizScore.total} ({quizScore.pct}%)
        </div>
      )}

      <div style={{ width: '100%', maxWidth: '440px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
        {PLANS.map(plan => {
          const isOpen = expanded === plan.id;
          return (
            <div
              key={plan.id}
              style={{
                background: isOpen
                  ? `linear-gradient(135deg, rgba(${plan.id==='basic'?'59,130,246':plan.id==='pro'?'129,140,248':'245,158,11'},0.12) 0%, rgba(255,255,255,0.04) 100%)`
                  : 'var(--bg-card-alt)',
                border: `2px solid ${isOpen ? plan.color : 'rgba(255,255,255,0.1)'}`,
                borderRadius: '18px',
                overflow: 'hidden',
                transition: 'border-color 0.25s',
                position: 'relative',
              }}
            >
              {/* شارة الأكثر شيوعاً */}
              {plan.recommended && (
                <div style={{
                  position: 'absolute', top: 0, right: isRTL ? 0 : 'auto', left: isRTL ? 'auto' : 0,
                  background: plan.color,
                  color: '#fff', fontSize: '11px', fontWeight: '700',
                  padding: '5px 14px',
                  borderRadius: isRTL ? '0 16px 0 12px' : '16px 0 12px 0',
                }}>
                  {t('plans_mostPopular')}
                </div>
              )}

              {/* رأس البطاقة — قابل للنقر */}
              <button
                onClick={() => setExpanded(isOpen ? null : plan.id)}
                style={{
                  width: '100%', background: 'none', border: 'none',
                  padding: '20px 20px 16px',
                  cursor: 'pointer', textAlign: 'right',
                  fontFamily: 'inherit',
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                }}
              >
                <div>
                  <div style={{ color: '#fff', fontSize: '19px', fontWeight: '800' }}>
                    {plan.icon} {t(plan.nameKey)}
                  </div>
                  <div style={{ color: 'rgba(255,255,255,0.45)', fontSize: '12px', marginTop: '3px' }}>
                    {t(plan.descKey)}
                  </div>
                </div>
                <div style={{ textAlign: 'left', display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <div>
                    <span style={{ color: plan.color, fontSize: '26px', fontWeight: '900' }}>
                      {plan.price}
                    </span>
                    <span style={{ color: 'var(--text-muted)', fontSize: '12px', marginRight: '3px' }}>
                      {t('perMonth')}
                    </span>
                  </div>
                  <span style={{
                    color: 'var(--text-muted)', fontSize: '18px',
                    transition: 'transform 0.2s',
                    transform: isOpen ? 'rotate(180deg)' : 'rotate(0)',
                    display: 'inline-block',
                  }}>
                    ▾
                  </span>
                </div>
              </button>

              {/* جدول المميزات */}
              {isOpen && (
                <div style={{ padding: '0 20px 20px' }}>
                  <div style={{
                    width: '100%',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    border: '1px solid var(--border)',
                  }}>
                    {FEATURES.map((f, i) => {
                      const has = plan.features[f.key];
                      return (
                        <div
                          key={f.key}
                          style={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            padding: '10px 14px',
                            background: i % 2 === 0 ? 'var(--bg-card-alt)' : 'transparent',
                            borderBottom: i < FEATURES.length - 1 ? '1px solid rgba(255,255,255,0.05)' : 'none',
                          }}
                        >
                          <span style={{
                            color: has ? 'rgba(255,255,255,0.85)' : 'var(--text-muted)',
                            fontSize: '13px',
                            fontWeight: has ? '500' : '400',
                          }}>
                            {t(f.labelKey)}
                          </span>
                          <span style={{
                            fontSize: '17px',
                            color: has ? '#4ade80' : 'var(--text-muted)',
                            fontWeight: '700',
                            minWidth: '24px', textAlign: 'center',
                          }}>
                            {has ? '✓' : '✕'}
                          </span>
                        </div>
                      );
                    })}
                  </div>

                  {/* زر الاشتراك */}
                  <button
                    onClick={() => onSelect(plan)}
                    style={{
                      width: '100%', marginTop: '14px',
                      padding: '14px',
                      background: plan.color,
                      border: 'none', borderRadius: '12px',
                      color: '#fff', fontSize: '15px', fontWeight: '700',
                      cursor: 'pointer', fontFamily: 'inherit',
                      boxShadow: `0 4px 20px ${plan.color}44`,
                      transition: 'opacity 0.2s',
                    }}
                    onMouseEnter={e => e.currentTarget.style.opacity = '0.88'}
                    onMouseLeave={e => e.currentTarget.style.opacity = '1'}
                  >
                    {t('plans_subscribe')} {t(plan.nameKey)}
                  </button>
                </div>
              )}
            </div>
          );
        })}
      </div>

      <button onClick={onBack}
        style={{
          marginTop: '28px', background: 'none', border: 'none',
          color: 'var(--text-muted)', fontSize: '13px',
          fontFamily: 'inherit', cursor: 'pointer',
          textDecoration: 'underline',
        }}>
        {t('back')}
      </button>

      {/* روابط قانونية */}
      <div style={{ marginTop: '24px', display: 'flex', gap: '20px', flexWrap: 'wrap', justifyContent: 'center' }}>
        {[
          { labelKey: 'plans_privacy', href: '/privacy.html' },
          { labelKey: 'plans_terms',   href: '/terms.html' },
          { labelKey: 'plans_refund',  href: '/refund.html' },
        ].map(link => (
          <a key={link.href} href={link.href} target="_blank" rel="noopener noreferrer"
            style={{ color: 'rgba(255,255,255,0.28)', fontSize: '12px', textDecoration: 'none', fontFamily: 'inherit', transition: 'color 0.2s' }}
            onMouseEnter={e => e.currentTarget.style.color = 'rgba(255,255,255,0.65)'}
            onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.28)'}
          >
            {t(link.labelKey)}
          </a>
        ))}
      </div>
      </div> {/* end content */}
    </div>
  );
}
